/*
 * @Author: Chao Yang
 * @Date: 2019-10-14 06:14:15
 * @LastEditor: Chao Yang
 * @LastEditTime: 2020-02-27 11:22:37
 */
import { NgModule } from '@angular/core';
import { HeaderModule } from './header/header.module';
import { FooterModule } from './footer/footer.module';
import { MenuModule } from './menu/menu.module';
import { AdCommonModule } from './common/index';
import { HeaderStatusComponent } from './header/header-status/header-status.component';

@NgModule({
  imports: [FooterModule, HeaderModule, MenuModule],
  exports: [AdCommonModule, FooterModule, HeaderModule, MenuModule,HeaderStatusComponent],
  declarations: []
})
export class SectionModule { }
